import React from 'react';
import { Button } from './ui/Button';
import { CheckCircle2, ShieldCheck, CreditCard } from 'lucide-react';
import { Card } from './ui/Card';
export function CheckoutSection() {
  const checkoutUrl = 'https://bolivia.edulabs.online/cart/44072226848851:1';
  const handleAddToCart = () => {
    // Track AddToCart event with Meta Pixel
    if (typeof window !== 'undefined' && (window as any).fbq) {
      ;
      (window as any).fbq('track', 'AddToCart', {
        content_name: 'MegaPack Música Lista',
        content_ids: ['44072226848851'],
        content_type: 'product',
        value: 82.9,
        currency: 'BOB'
      });
    }
  };
  return <section className="py-24 bg-gray-50" id="comprar" data-id="element-39">
      <div className="container mx-auto px-4" data-id="element-40">
        <div className="max-w-6xl mx-auto" data-id="element-41">
          <Card className="overflow-hidden shadow-2xl border-0 ring-2 ring-gray-200" data-id="element-42">
            <div className="grid grid-cols-1 md:grid-cols-2" data-id="element-43">
              {/* Product Image Side */}
              <div className="relative h-80 md:h-auto bg-gray-100" data-id="element-44">
                <img src="https://cdn.magicpatterns.com/uploads/qEyZHLn1rmxiPdRc6jykHp/heylloyd-image-1771781222157.png" alt="MegaPack Música Lista - Edición Completa" className="w-full h-full object-cover" data-id="element-45" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent flex items-end p-8 md:hidden" data-id="element-46">
                  <span className="bg-red-600 text-white px-4 py-2 rounded-full text-base font-black shadow-xl" data-id="element-47">
                    Oferta Especial
                  </span>
                </div>
              </div>

              {/* Pricing & CTA Side */}
              <div className="p-10 md:p-14 flex flex-col justify-center bg-white" data-id="element-48">
                <div className="mb-8" data-id="element-49">
                  <div className="flex flex-wrap items-center gap-3 mb-4" data-id="element-50">
                    <span className="bg-red-100 text-red-700 px-4 py-2 rounded-full text-sm font-black uppercase tracking-wide" data-id="element-51">
                      Oferta Limitada
                    </span>
                    <span className="text-green-600 text-base font-bold flex items-center gap-2" data-id="element-52">
                      <ShieldCheck className="w-5 h-5" data-id="element-53" /> Garantía de
                      Satisfacción
                    </span>
                  </div>

                  <h2 className="text-4xl md:text-5xl font-serif font-black text-gray-900 mb-3 leading-tight" data-id="element-54">
                    MegaPack Música Lista
                  </h2>
                  <p className="text-lg text-gray-600 mb-8 leading-relaxed" data-id="element-55">
                    Acceso inmediato a todos los recursos, planificaciones y
                    bonos exclusivos.
                  </p>

                  <div className="flex items-end gap-5 mb-10" data-id="element-56">
                    <div className="flex flex-col" data-id="element-57">
                      <span className="text-gray-400 text-xl line-through font-semibold" data-id="element-58">
                        169,90 Bs
                      </span>
                      <span className="text-5xl md:text-6xl font-black text-gray-900 tracking-tighter leading-none" data-id="element-59">
                        82,90 Bs
                      </span>
                    </div>
                    <span className="mb-3 bg-green-100 text-green-700 px-3 py-2 rounded-lg text-base font-black" data-id="element-60">
                      -51% OFF
                    </span>
                  </div>

                  <a href={checkoutUrl} target="_blank" rel="noopener noreferrer" onClick={handleAddToCart} className="block w-full" data-id="element-61">
                    <Button size="lg" variant="primary" className="w-full text-xl font-black py-7 shadow-xl shadow-red-200 hover:shadow-2xl hover:shadow-red-300 transform transition-all hover:-translate-y-1" data-id="element-62">
                      Adquirir el Pack
                    </Button>
                  </a>

                  <p className="text-center text-sm text-gray-500 mt-4 flex items-center justify-center gap-2 font-medium" data-id="element-63">
                    <CreditCard className="w-4 h-4" data-id="element-64" />
                    Pago seguro y protegido
                  </p>
                </div>

                <div className="border-t-2 border-gray-100 pt-8" data-id="element-65">
                  <h4 className="text-base font-black text-gray-900 mb-5 uppercase tracking-wide" data-id="element-66">
                    Lo que recibís hoy:
                  </h4>
                  <ul className="space-y-3" data-id="element-67">
                    <li className="flex items-start gap-3 text-base text-gray-700" data-id="element-68">
                      <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-69" />
                      Planificaciones Primaria y Secundaria
                    </li>
                    <li className="flex items-start gap-3 text-base text-gray-700" data-id="element-70">
                      <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-71" />
                      Banco de dinámicas musicales
                    </li>
                    <li className="flex items-start gap-3 text-base text-gray-700" data-id="element-72">
                      <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-73" />
                      Proyectos completos (ensamble / creación / muestra)
                    </li>
                    <li className="flex items-start gap-3 text-base text-gray-700" data-id="element-74">
                      <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-75" />
                      Kit editable + planillas de seguimiento
                    </li>
                    <li className="flex items-start gap-3 text-base text-gray-700" data-id="element-76">
                      <CheckCircle2 className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-77" />
                      Acceso de por vida a actualizaciones
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </Card>
        </div>
      </div>
    </section>;
}